module.exports = __webpack_public_path__ + "static/ez-1baf3f098bc59e2442dd6e950342674e.png";